import type { GameLinkView, GmGameView } from '#src/interfaces/gameManager'
import { pluginState } from '#src/sevenIgamingPlugin'
import { resolveDevLocalGameLaunchUrl } from '#src/utils/devLocalGameEnv'

const getGameDisplayName = (gameLink: GameLinkView) => {
  const { language } = pluginState

  let gameTranslation = gameLink.localizations?.find(
    ({ locale }) => locale === language
  )?.nameTranslation

  if (gameTranslation) {
    return gameTranslation
  }

  gameTranslation = gameLink.installation.game.localizations?.find(
    ({ locale }) => locale === language
  )?.nameTranslation

  if (gameTranslation) {
    return gameTranslation
  }

  return gameLink.installation.game.name
}

const getGameThumbnail = (game: GmGameView) =>
  game.images?.thumb ?? game.images?.medium ?? game.images?.large ?? undefined

const getGameUrls = (game: GmGameView) => {
  const devLocalUrl = resolveDevLocalGameLaunchUrl(game)

  if (devLocalUrl) {
    return { ssbtUrl: devLocalUrl, posUrl: devLocalUrl }
  }

  return {
    ssbtUrl: game.urls?.ssbtUrls?.launchUrl.url,
    posUrl: game.urls?.retailUrls?.launchUrl.url
  }
}

export { getGameDisplayName, getGameThumbnail, getGameUrls }
